import { TAdditionalService } from 'redux/reducers/emManagement/types';
import { TTableStructure, ETableStructureType, ETableStructureAlign } from 'ui/EasTable/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { Edit } from '@mui/icons-material';
import { EIconButtons } from '../../../ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<keyof TAdditionalService>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Name',
		selector: 'name',
		show: true,
		sortable: true,
		filterable: true,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Price',
		selector: 'price',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.RIGHT,
		editable: true,
	},
	{
		name: 'Recurring',
		selector: 'isRecurring',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colors: [
			['true', 'success.light'],
			['false', 'warning.light'],
		],
		editable: true,
	},
	{
		name: 'Service Period',
		selector: 'servicePeriod',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		editable: true,
	},
	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		editable: false,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		editable: false,
	},
	{
		name: 'Created By',
		selector: 'createdBy',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		editable: false,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		editable: false,
	},
	{
		name: 'Actions',
		selector: 'id',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
		],
	},
];
